import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import '@progress/kendo-theme-material/dist/all.css';
// import "@progress/kendo-theme-bootstrap/dist/all.scss";

import './shared/styles/index.css';
import './assets/fonts/font.scss';
import './assets/styles/cargo/indexPage/style.scss';
import App from './App';
import '@crema/services';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
